import React from "react";
import { makeStyles } from "@material-ui/core";

let responsiveLength = "1000";

let useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        margin: '100px auto 10px auto',
        flexWrap: 'wrap',
        padding: 50,
        [theme.breakpoints.down('400')]: {
            padding: "30px 20px",
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        right: '50%',
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    desc: {
        width: '50%',
        margin: "10px auto",
        fontSize: 16,
        minWidth: 600,
        maxWidth: '100%',
        [theme.breakpoints.down('750')]: {
            minWidth: '100%',
        },

    },
    content: {
        position: 'relative'
    },
    title: {
        fontSize: 28,
    },
    gridBtns: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        margin: '50px auto',
    },
    btns: {
        width: '49.5%',
        height: 50,
        borderRadius: 5,
        border: "none",
        fontSize: 16,
        backgroundColor: '#F9F9FF',
        background: "#F9F9FF",
        marginBottom: 10,
        cursor: 'pointer',
        [theme.breakpoints.down('910')]: {
            minWidth: '100%',
        },
    },

}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['girdContent']}>
                <div className={classes['content']}>
                    <div className={classes['line']} />
                    <h3 className={classes['title']}>
                        خدمات کارگزاری پویان در بورس انرژی
                    </h3>
                </div>
                <div className={classes['gridBtns']}>
                    <button type="text" className={classes['btns']}>
                        خرید با بهترین قیمت در معاملات رقابتی
                    </button>
                    <button type="text" className={classes['btns']}>
                        اخذ کد بورس انرژی برای شرکت‌های داخلی و خارجی
                    </button>
                    <button type="text" className={classes['btns']}>
                        برگزاری دوره های آموزشی
                    </button>
                    <button type="text" className={classes['btns']}>
                        پذیرش و عرضه کالاهای داخلی و وارداتی
                    </button>
                    <button type="text" className={classes['btns']}>
                        گزارشات و آمار معاملات روزانه
                    </button>
                    <button type="text" className={classes['btns']}>
                        مشاوره‌های تخصصی
                    </button>
                    <button type="text" className={classes['btns']}>
                        ارائه تحلیل‌های تخصصی در حوزه انرژی
                    </button>
                    <button type="text" className={classes['btns']}>
                        ارائه قیمت‌های جهانی فرآورده‌های نفتی
                    </button>

                </div>
               
            </div>
        </div>
    )
}
